<template>
	<div class="home">
		<div>
			<template v-if="details?.path">
				<img src="@/assets/images/new/mask-top-right.png" class="bg-t-r" />
				<!-- <img src="@/assets/images/new/mask-bottom-left.png" class="bg-b-l" /> -->
				<div class="logo"><img src="@/assets/images/logo.png" /></div>
				<div class="banner" @click="onDetails">
					<img class="b_g" :src="details?.path" />
					<div class="text floaterig">点击查看详情>></div>
				</div>
				<!-- <div class="flexBox">
				<div class="flexItem" v-for="(item, index) in tab" :key="index" @click="onItem(item, index)">
					<img v-if="index == 0 && !iconUrl" src="@/assets/images/flex_1.png" style="opacity: 0" />
					<img v-if="index == 0 && iconUrl" :src="iconUrl" />
					<img v-if="index == 1" src="@/assets/images/flex_2.png" />
					<img v-if="index == 2" src="@/assets/images/flex_3.png" />
					<img v-if="index == 3" src="@/assets/images/flex_4.png" />
					<h4>{{ item.title || '' }}</h4>
				</div>
			</div> -->
				<div class="nav">
					<div class="position">
						<div class="navItem" v-for="(item, index) in nav" :key="index" :style="{ backgroundImage: `url(${item?.icon})` }">
							<div class="box" @click.stop="onItem(item, index)" :class="{ white: item?.white }">
								<h2 v-text="item?.title || ``" />
								<p>
									了解更多
									<svg width="9.5px" height="11.5px">
										<path
											fill-rule="evenodd"
											stroke-width="1px"
											stroke-linecap="butt"
											stroke-linejoin="miter"
											opacity="0.502"
											fill="none"
											d="M1.038,1.002 L6.954,5.502 L1.038,10.003 "
										/>
									</svg>
								</p>
							</div>
						</div>
					</div>
				</div>
			</template>
			<float-btn-slot>
				<img src="@/assets/images/aiIcon.png" class="aiBtn" @click.stop="goAi" />
			</float-btn-slot>
		</div>
	</div>
</template>

<script>
import { Toast, SwipeCell } from 'vant';
import Crypt from '@bluedot-tech/vue-ui/es/utils/crypt';
import config from '../config/config';
import floatBtn from '@/components/FloatBtn.vue';
import floatBtnSlot from '@/components/FloatBtnSlot.vue';
export default {
	components: {
		floatBtn,
		floatBtnSlot,
		[SwipeCell.name]: SwipeCell
	},
	data() {
		return {
			iconUrl: '',
			details: {},
			/* tab: [
				{
					title: '',
					path: '/cibf-list'
				},
				{
					title: '产品简介',
					path: '/list-class'
				},
				{
					title: '资料下载',
					path: 'https://clould-app.lookstar.com.cn/data-download?tenant=6c3fa2b0-c5be-471d-8c73-4a831e22aea9&project=1499&appid=wxd0e450f42accad28&utm_campaign=3d&utm_source=%E8%85%BE%E8%AE%AF',
					isWeb: true
				},
				{
					title: '联系我们',
					path: 'https://landing-release.lookstar.com.cn/pages/5beb0ed9-015d-4c8e-971a-cc644396a8f7?appid=wxd0e450f42accad28&utm_campaign=3D%E8%81%94%E7%B3%BB%E6%88%91%E4%BB%AC&utm_source=%E8%85%BE%E8%AE%AF',
					isWeb: true
				}
			], */
			nav: [
				{
					title: `行业应用`,
					path: `/industrylist`,
					icon: require(`@/assets/images/new/t1.png`)
				},
				{
					// 产品简介
					title: '产品中心',
					path: '/list-class',
					icon: require(`@/assets/images/new/t2.png`)
				},
				{
					title: '资料下载',
					path: 'https://clould-app.lookstar.com.cn/data-download?tenant=6c3fa2b0-c5be-471d-8c73-4a831e22aea9&project=1499&appid=wxd0e450f42accad28&utm_campaign=3d&utm_source=%E8%85%BE%E8%AE%AF',
					isWeb: true,
					icon: require(`@/assets/images/new/t3.png`)
				},
				{
					title: '样品申请',
					path: '/sample',
					icon: require(`@/assets/images/new/t4.png`)
				},
				{
					// 最新活动
					title: '活动预告',
					path: '/cibf-list',
					icon: require(`@/assets/images/new/t5.png`)
				},
				{
					title: '联系我们',
					path: 'https://landing-release.lookstar.com.cn/pages/5beb0ed9-015d-4c8e-971a-cc644396a8f7?appid=wxd0e450f42accad28&utm_campaign=3D%E8%81%94%E7%B3%BB%E6%88%91%E4%BB%AC&utm_source=%E8%85%BE%E8%AE%AF',
					isWeb: true,
					icon: require(`@/assets/images/new/t6.png`),
					white: true
				}
			]
		};
	},
	beforeMount() {
		this.$loading.show();
	},
	created() {
		this.$loading.show();
		this.getData();
	},
	beforeCreate() {
		this.$loading.show();
	},
	mounted() {
		// 页面浏览 监测
		this.$dataStatistics({
			page_title: '首页'
		});

		this.initShare();
		// 环境变量获取方法
		// console.log('process.env', process.env);
	},
	methods: {
		swiperChange(e) {
			this.$refs.swiper.close();
		},
		onItem(item, index) {
			console.log(item);
			let path = item.path;
			if (!path) return;

			if (item?.title == '联系我们') {
				// this.scoreAdd();
			}
			this.$dataStatistics({ event_type: 'click', page_title: '首页' }, `${item?.title}`);

			if (item.isWeb) {
				window.location.href = path;
			} else {
				localStorage.removeItem('list-index');
				this.$router.push({ path: path, query: item.query || {} });
			}
		},
		onDetails() {
			this.$router.push({ path: '/details' });

			this.$dataStatistics({ event_type: 'click', page_title: '首页' }, '顶部图片');
		},
		async getData() {
			this.$loading.show();
			let list = this.getList();
			let data = this.getDetails();

			Promise.all([list, data]).then((res) => {
				this.$nextTick(() => {
					this.$loading.hide();
				});
			});
		},
		getList() {
			return new Promise((resolve) => {
				this.$http.get('/api/platform/module/5?filter[type]=2').then((res) => {
					console.log('res', res);
					this.iconUrl = res.data.path;
					// const cibfIndex = this.tab?.findIndex((item) => item?.path == `/cibf-list`);
					// this.tab[cibfIndex].title = res.data.title;
					const cibfIndex = this.nav?.findIndex((item) => item?.path == `/cibf-list`);
					this.nav[cibfIndex].title = res.data.title;

					this.$nextTick(() => {
						resolve(res);
					});
				});
			});
		},
		getDetails() {
			return new Promise((resolve) => {
				this.$http.get('/api/platform/module/6?filter[type]=1').then((res) => {
					console.log('res', res);
					this.details = res.data;
					this.$nextTick(() => {
						resolve(res);
					});
				});
			});
		},
		scoreAdd() {
			return new Promise((resolve, reject) => {
				//加积分
				let data = { source: '联系我们', type: 6 };
				this.$http
					.post('/api/platform/user/score', data)
					.then((res) => {
						console.log('res', res);
						if (res?.data?.errcode) {
							reject();
						}
						resolve();
					})
					.catch((err) => {
						reject();
					});
			});
		}
		// onClick() {
		// 	this.$router.push('/about');
		// },
		// onSubmit() {
		// 	const crypt = new Crypt(config.crypto.publickey);
		// 	const email = '1198810568@qq.com';
		// 	const phone = '15812040230';
		// 	this.$http
		// 		.post('/xxx/xxx', {
		// 			first_name: '测试',
		// 			last_name: '3号',
		// 			phone: crypt.aes_encrypt(phone),
		// 			email: crypt.aes_encrypt(email),
		// 			crypt_key: crypt.rsa_key_encrypt()
		// 		})
		// 		.then(res => {
		// 			Toast('提交成功');
		// 		});
		// }
	}
};
</script>
<style lang="less" scoped>
.home {
	background: #fff;

	.bg-t-r {
		position: fixed;
		top: 0;
		right: 0;
		z-index: 4;
		display: block;
		width: 222px;
		height: 204px;
		pointer-events: none;
	}

	.bg-b-l {
		position: fixed;
		bottom: 0;
		left: 0;
		z-index: 4;
		display: block;
		width: 189px;
		height: 227px;
		pointer-events: none;
	}

	.logo {
		position: fixed;
		top: 27px;
		left: 35px;
		width: 214px;
		height: 55px;
		display: block;
		z-index: 111;
		& > img {
			width: 100%;
		}
	}

	.banner {
		margin-top: 110px;
		position: relative;
		height: 440px;
		z-index: 0;
		margin-bottom: 40px;

		.b_g {
			// position: absolute;
			// top: 0;
			// left: 0;
			width: 100%;
			height: 100%;
			object-fit: cover;
			z-index: 0;
			opacity: 1 !important;
		}

		.perch {
			width: 120px;
			height: 100%;
		}

		.text {
			position: absolute;
			right: 30px;
			bottom: 19px;
			font-size: 28px;
			font-weight: 400;
			color: @theme;
		}
	}

	.main {
		position: relative;
		z-index: 11;
		// margin-top: calc(630px - (30px * 1.5 - 30px) / 2);
		margin-top: 18px;
		padding: 0 60px;

		.title {
			font-size: 32px;
			font-weight: bold;
			text-align: center;
			color: @theme;
			line-height: 1.5;
		}
	}

	.flexBox {
		position: fixed;
		z-index: 111;
		bottom: 0;
		left: 50%;
		transform: translateX(-50%);
		width: 704px;
		height: 692px;
		background: rgba(255, 255, 255, 0.4);
		border: 3px solid #ffffff;
		box-shadow: 0px -9px 65px 0px rgba(0, 0, 0, 0.13);
		display: flex;
		flex-wrap: wrap;
		padding: 148px 77px 190px;
		.flexItem {
			flex: 0 0 auto;
			width: calc(100% / 2);
			height: calc(120px + 52px);
			text-align: center;
			padding-bottom: 52px;
			margin-bottom: 52px;
			display: flex;
			align-content: space-between;
			justify-content: center;
			flex-wrap: wrap;
			img {
				display: block;
				overflow: hidden;
				width: auto;
				height: 43px;
				flex: 0 0 auto;
			}

			h4 {
				flex: 0 0 auto;
				width: 100%;
				font-size: 30px;
				font-weight: normal;
				color: #000000;
				line-height: 50px;
			}

			&:nth-child(1),
			&:nth-child(2) {
				border-bottom: 1.5px solid #999999;
			}

			&:nth-child(1),
			&:nth-child(3) {
				position: relative;
				&::after {
					content: '';
					display: block;
					position: absolute;
					right: 0;
					top: 50%;
					transform: translateX(50%) translateY(calc(-50% - 52px / 2));
					width: 1.5px;
					height: 120px;
					background-color: #999;
				}
			}
		}
	}

	.nav {
		width: 828px;
		padding: 0 36px 40px;

		.position {
			position: relative;
			z-index: 11;
			width: 100%;
			height: 766px;

			.navItem {
				position: absolute;
				z-index: 1;
				padding: 30px;
				background: no-repeat center center;
				background-size: 100% 100%;
				border-radius: 12px;
				overflow: hidden;
				width: 360px;

				&:nth-child(1) {
					top: 0;
					left: 0;
					height: 370px;
				}
				&:nth-child(2) {
					top: 0;
					left: 396px;
					height: 270px;
				}
				&:nth-child(3) {
					top: 398px;
					left: 0;
					height: 170px;
				}
				&:nth-child(4) {
					top: 298px;
					left: 396px;
					height: 270px;
				}
				&:nth-child(5) {
					top: 596px;
					left: 0;
					height: 170px;
				}
				&:nth-child(6) {
					top: 596px;
					left: 396px;
					height: 170px;
				}

				.box {
					height: 100%;
					flex: 0 0 auto;

					h2 {
						font-weight: normal;
						font-size: 36px;
						color: #333333;
						line-height: 1;
						margin-bottom: 20px;
					}

					p {
						font-weight: normal;
						font-size: 26px;
						color: #000000;
						line-height: 1;
						opacity: 0.45;
						display: flex;
						align-items: center;

						svg {
							margin-left: 8px;

							path {
								stroke: rgb(7, 1, 2);
							}
						}
					}

					&.white {
						* {
							color: #fff;
							stroke: #fff;
							opacity: 1;
						}
					}
				}
			}
		}
	}

	.btn {
		position: fixed;
		z-index: 112;
		right: 20px;
		bottom: 20px;
		width: 93px;
		height: 93px;
		display: block;
		img {
			width: 100%;
			height: 100%;
			display: block;
		}
	}

	.aiBtn {
		width: 166px;
		height: 166px;
		display: block;
	}
}
.floaterig {
	animation-name: floaterig;
	-webkit-animation-name: floaterig;

	animation-duration: 2s;
	-webkit-animation-duration: 2s;

	animation-iteration-count: infinite;
	-webkit-animation-iteration-count: infinite;

	visibility: visible !important;
}

@keyframes floaterig {
	0% {
		transform: translateX(0%);
	}
	50% {
		transform: translateX(-20%);
	}
	100% {
		transform: translateX(0%);
	}
}

@-webkit-keyframes floaterig {
	0% {
		-webkit-transform: translateX(0%);
	}
	50% {
		-webkit-transform: translateX(-20%);
	}
	100% {
		-webkit-transform: translateX(0%);
	}
}
</style>
